const initialState = {
  objectives: {
    data: [],
    loading: false,
    error: null,
    savingById: {},
    deletingById: {},
    completingById: {},
  },
  metas: {
    savingById: {},
    deletingById: {},
    error: null,
  },
  recursos: {
    savingById: {},
    deletingById: {},
    error: null,
  },
  responsables: {
    savingById: {},
    deletingById: {},
    error: null,
  },
  estrategias: {
    savingById: {},
    deletingById: {},
    error: null,
  },
};

// Helpers inmutables para flags por id
const setFlag = (map, id, value = true) => ({ ...map, [id]: value });
const clearFlag = (map, id) => {
  const { [id]: _ignored, ...rest } = map;
  return rest;
};

const improvementPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    /* ============== OBJECTIVES ============== */
    case "SAVE_OBJECTIVE_REQUEST": {
      const { id } = action.payload;
      return {
        ...state,
        objectives: {
          ...state.objectives,
          error: null,
          savingById: setFlag(state.objectives.savingById, id),
        },
      };
    }
    case "SAVE_OBJECTIVE_SUCCESS": {
      const { id } = action.payload;
      return {
        ...state,
        objectives: {
          ...state.objectives,
          savingById: clearFlag(state.objectives.savingById, id),
          error: null,
        },
      };
    }
    case "SAVE_OBJECTIVE_FAIL": {
      const { id, error } = action.payload;
      return {
        ...state,
        objectives: {
          ...state.objectives,
          savingById: clearFlag(state.objectives.savingById, id),
          error,
        },
      };
    }

    case "GET_ALL_OBJECTIVE_REQUEST":
      return {
        ...state,
        objectives: { ...state.objectives, loading: true, error: null },
      };
    case "GET_ALL_OBJECTIVE_SUCCESS":
      return {
        ...state,
        objectives: {
          ...state.objectives,
          data: action.payload || [],
          loading: false,
          error: null,
        },
      };
    case "GET_ALL_OBJECTIVE_FAIL":
      return {
        ...state,
        objectives: {
          ...state.objectives,
          data: [],
          loading: false,
          error: action.payload,
        },
      };

    case "DELETE_OBJECTIVE_REQUEST": {
      const { id } = action.payload;
      return {
        ...state,
        objectives: {
          ...state.objectives,
          error: null,
          deletingById: setFlag(state.objectives.deletingById, id),
        },
      };
    }
    case "DELETE_OBJECTIVE_SUCCESS": {
      const { id } = action.payload;
      return {
        ...state,
        objectives: {
          ...state.objectives,
          deletingById: clearFlag(state.objectives.deletingById, id),
          error: null,
        },
      };
    }
    case "DELETE_OBJECTIVE_FAIL": {
      const { id, error } = action.payload;
      return {
        ...state,
        objectives: {
          ...state.objectives,
          deletingById: clearFlag(state.objectives.deletingById, id),
          error,
        },
      };
    }

    case "COMPLETE_OBJECTIVE_REQUEST": {
      const { id } = action.payload;
      return {
        ...state,
        objectives: {
          ...state.objectives,
          error: null,
          completingById: setFlag(state.objectives.completingById, id),
        },
      };
    }
    case "COMPLETE_OBJECTIVE_SUCCESS": {
      const { id } = action.payload;
      return {
        ...state,
        objectives: {
          ...state.objectives,
          completingById: clearFlag(state.objectives.completingById, id),
          error: null,
        },
      };
    }
    case "COMPLETE_OBJECTIVE_FAIL": {
      const { id, error } = action.payload;
      return {
        ...state,
        objectives: {
          ...state.objectives,
          completingById: clearFlag(state.objectives.completingById, id),
          error,
        },
      };
    }

    /* ============== METAS ============== */
    case "SAVE_META_REQUEST": {
      const { id } = action.payload;
      return {
        ...state,
        metas: {
          ...state.metas,
          error: null,
          savingById: setFlag(state.metas.savingById, id),
        },
      };
    }
    case "SAVE_META_SUCCESS": {
      const { id } = action.payload;
      return {
        ...state,
        metas: {
          ...state.metas,
          savingById: clearFlag(state.metas.savingById, id),
          error: null,
        },
      };
    }
    case "SAVE_META_FAIL": {
      const { id, error } = action.payload;
      return {
        ...state,
        metas: {
          ...state.metas,
          savingById: clearFlag(state.metas.savingById, id),
          error,
        },
      };
    }

    case "DELETE_META_REQUEST": {
      const { id } = action.payload;
      return {
        ...state,
        metas: {
          ...state.metas,
          error: null,
          deletingById: setFlag(state.metas.deletingById, id),
        },
      };
    }
    case "DELETE_META_SUCCESS": {
      const { id } = action.payload;
      return {
        ...state,
        metas: {
          ...state.metas,
          deletingById: clearFlag(state.metas.deletingById, id),
          error: null,
        },
      };
    }
    case "DELETE_META_FAIL": {
      const { id, error } = action.payload;
      return {
        ...state,
        metas: {
          ...state.metas,
          deletingById: clearFlag(state.metas.deletingById, id),
          error,
        },
      };
    }

    /* ============== RECURSOS ============== */
    case "SAVE_RECURSO_REQUEST": {
      const { id } = action.payload;
      return {
        ...state,
        recursos: {
          ...state.recursos,
          error: null,
          savingById: setFlag(state.recursos.savingById, id),
        },
      };
    }
    case "SAVE_RECURSO_SUCCESS": {
      const { id } = action.payload;
      return {
        ...state,
        recursos: {
          ...state.recursos,
          savingById: clearFlag(state.recursos.savingById, id),
          error: null,
        },
      };
    }
    case "SAVE_RECURSO_FAIL": {
      const { id, error } = action.payload;
      return {
        ...state,
        recursos: {
          ...state.recursos,
          savingById: clearFlag(state.recursos.savingById, id),
          error,
        },
      };
    }

    case "DELETE_RECURSO_REQUEST": {
      const { id } = action.payload;
      return {
        ...state,
        recursos: {
          ...state.recursos,
          error: null,
          deletingById: setFlag(state.recursos.deletingById, id),
        },
      };
    }
    case "DELETE_RECURSO_SUCCESS": {
      const { id } = action.payload;
      return {
        ...state,
        recursos: {
          ...state.recursos,
          deletingById: clearFlag(state.recursos.deletingById, id),
          error: null,
        },
      };
    }
    case "DELETE_RECURSO_FAIL": {
      const { id, error } = action.payload;
      return {
        ...state,
        recursos: {
          ...state.recursos,
          deletingById: clearFlag(state.recursos.deletingById, id),
          error,
        },
      };
    }

    /* ============== ESTRATEGIAS ============== */
    case "SAVE_ESTRATEGIA_REQUEST": {
      const { id } = action.payload;
      return {
        ...state,
        estrategias: {
          ...state.estrategias,
          error: null,
          savingById: setFlag(state.estrategias.savingById, id),
        },
      };
    }
    case "SAVE_ESTRATEGIA_SUCCESS": {
      const { id } = action.payload;
      return {
        ...state,
        estrategias: {
          ...state.estrategias,
          savingById: clearFlag(state.estrategias.savingById, id),
          error: null,
        },
      };
    }
    case "SAVE_ESTRATEGIA_FAIL": {
      const { id, error } = action.payload;
      return {
        ...state,
        estrategias: {
          ...state.estrategias,
          savingById: clearFlag(state.estrategias.savingById, id),
          error,
        },
      };
    }

    case "DELETE_ESTRATEGIA_REQUEST": {
      const { id } = action.payload;
      return {
        ...state,
        estrategias: {
          ...state.estrategias,
          error: null,
          deletingById: setFlag(state.estrategias.deletingById, id),
        },
      };
    }
    case "DELETE_ESTRATEGIA_SUCCESS": {
      const { id } = action.payload;
      return {
        ...state,
        estrategias: {
          ...state.estrategias,
          deletingById: clearFlag(state.estrategias.deletingById, id),
          error: null,
        },
      };
    }
    case "DELETE_ESTRATEGIA_FAIL": {
      const { id, error } = action.payload;
      return {
        ...state,
        estrategias: {
          ...state.estrategias,
          deletingById: clearFlag(state.estrategias.deletingById, id),
          error,
        },
      };
    }

    /* ============== RESPONSABLES ============== */
    case "SAVE_RESPONSABLE_REQUEST": {
      const { id } = action.payload;
      return {
        ...state,
        responsables: {
          ...state.responsables,
          error: null,
          savingById: setFlag(state.responsables.savingById, id),
        },
      };
    }
    case "SAVE_RESPONSABLE_SUCCESS": {
      const { id } = action.payload;
      return {
        ...state,
        responsables: {
          ...state.responsables,
          savingById: clearFlag(state.responsables.savingById, id),
          error: null,
        },
      };
    }
    case "SAVE_RESPONSABLE_FAIL": {
      const { id, error } = action.payload;
      return {
        ...state,
        responsables: {
          ...state.responsables,
          savingById: clearFlag(state.responsables.savingById, id),
          error,
        },
      };
    }

    case "DELETE_RESPONSABLE_REQUEST": {
      const { id } = action.payload;
      return {
        ...state,
        responsables: {
          ...state.responsables,
          error: null,
          deletingById: setFlag(state.responsables.deletingById, id),
        },
      };
    }
    case "DELETE_RESPONSABLE_SUCCESS": {
      const { id } = action.payload;
      return {
        ...state,
        responsables: {
          ...state.responsables,
          deletingById: clearFlag(state.responsables.deletingById, id),
          error: null,
        },
      };
    }
    case "DELETE_RESPONSABLE_FAIL": {
      const { id, error } = action.payload;
      return {
        ...state,
        responsables: {
          ...state.responsables,
          deletingById: clearFlag(state.responsables.deletingById, id),
          error,
        },
      };
    }

    default:
      return state;
  }
};

export default improvementPlanReducer;
